import * as actionTypes from "./actionTypes";
import * as actions from './index';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { checkMultiSort } from 'Flow2/components/Share/FlexSearch/FlexSearchConfig/FlexSearchConfig';

export const updateFlexObjectsSuccess = (data) => {
    return {
        type: actionTypes.FLEX_UPDATE_FLEXOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateFlexObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateFlexObjectsSuccess(obj));
    }
}

export const getSearchTags = ({ dispatch, search, options }) => {
    let data = [];
    window.flow.searchTags(search, options).then((res) => {
        if (res) {
            for (let i in res) {
                if (res[i].id) {
                    let txt = res[i].word;
                    if (res[i].cat) txt += `(${res[i].cat})`;
                    data.push({ ...res[i], ID: res[i].id, DE: txt, EN: txt });
                }
            }
        }
        dispatch(actions.updateFlexObjects({ flexTags: data }));
    }).catch(err => {
        console.log("LOGS: getFlexTags err", err);
    });
}

export const getFlexTags = (search = "", options = { op: "listall", searchterm: "" }) => {
    let data = [];
    console.log("LOGS: getFlexTags START");
    return (dispatch, getState) => {
        let res;
        if (getState().tags && getState().tags.tags) {
            res = getState().tags.tags;
        }
        if (res) {
            for (let i in res) {
                if (res[i].id) {
                    let txt = res[i].word;
                    if (res[i].cat) txt += `(${res[i].cat})`;
                    data.push({ ...res[i], ID: res[i].id, DE: txt, EN: txt });
                }
            }
            console.log("LOGS: getFlexTags data.length", data.length);
            dispatch(actions.updateFlexObjects({ flexTags: data }));
        }
    };
};


export const saveUserSearchDataSuccess = (res) => {
    return {
        type: actionTypes.FLEX_SAVE_USERSEARCHDATA_SUCCESS,
        payload: res
    }
}

export function saveUserSearchData({ user, option, data }) {
    let userid = user.id;
    let groupid = user.groupid;
    return dispatch => {
        window.flow.grantingEditUser(parseInt(groupid), parseInt(userid), [
            { 'name': option, 'value': [...data] }
        ], true).then((res) => {
            console.log("LOGS:saveUserSearchData", res)
        }).catch(err => {
            console.log("LAMTEST grantingEditUser err", err);
        });
    }
}

export const searchProfi = ({ params, customSortOption, isNext = false }) => {
    let fields = params.fields ? [...params.fields] : [];
    const clipsPerPage = 50;
    let offset = params.offset || 0;
    return (dispatch, getState) => {
        const filter = getState().ui.filter;
        const devices = Object.keys(getState().devices.searchDevices);
        const remoteSearch = (devices.length) ? { remoteserverdevice: devices.join(','), combineremote: true } : {};
        if (!isNext) {
            let configClipInfo = getState().customData.customConfigClipInfoForApp;
            customSortOption.field = DataUtil.getSortOptionsForApp(customSortOption.field, configClipInfo);
            if (customSortOption.field === 'undefined') customSortOption.field = 'id';
            fields.push(customSortOption);
        } else {
            if (customSortOption) fields.push(customSortOption);
            dispatch(actions.searchNextStart());
        }

        if (DataUtil.isPorscheArchiv()) {
            fields = [{ field: '', type: 'BEGIN_GROUP', value: '' }, ...fields,
            { field: '', type: 'END_GROUP', value: '' }];
            fields = actions.getSearchFilter(fields, filter);
            dispatch(actions.updateFlexObjects({ currentSearch: { type: 'byfields', fields: [...fields] } }));
            fields = checkMultiSort({ getState, dispatch, fields, type: 'byfields', params });
        }

        console.log("LOGS: LAMTEST searchProfi fields", fields);
        //console.log("LOGS: LAMTEST searchProfi params", params);
        window.flow.getClipsByFields(fields, { ...remoteSearch, offset, limit: clipsPerPage })
            .then((result) => {
                console.log("LOGS: LAMTEST searchProfi result", result);
                if (isNext) {
                    dispatch(actions.searchNextSuccess(result));
                } else {
                    if (DataUtil.isPorscheArchiv()) {
                        let sOption = params.customCurrentSortOption;
                        if (!sOption && customSortOption) {
                            sOption = `${customSortOption.field}|${customSortOption.type}`;
                        }
                        dispatch(actions.getCustomLastSearch({
                            searchType: 'byfields',
                            params: { ...params, customCurrentSortOption: sOption }
                        }));
                    }
                    dispatch(actions.searchSuccess(result));
                }
                dispatch(actions.setClipList(null, null));
            }).catch((err) => {
                console.log("LOGS: searchProfi err", err);
                dispatch(actions.applicationError(err.message));
            })
    }
}

export const searchAll = async (obj) => {
    try {
        let res;
        let adv = { offset: obj.offset, limit: obj.limit };
        if (obj.type === 'fulltext') {
            if (obj.extObj.fields) adv.fields = obj.extObj.fields;
            res = await window.flow.getClipsByFulltext(obj.params.keyword, adv);
            //console.log("LOGS: searchAll res", res);
        }
        if (obj.type === 'byfields') res = await window.flow.getClipsByFields(obj.fields, adv);
        if (res && res.objects && res.objects && res.objects.elements
        ) {
            let elements = res.objects.elements;
            let len = Object.keys(elements).length;
            Object.keys(elements).forEach(id => {
                obj.flexClips.push({ id: id, metadata: elements[id].data.metadata.fields });
            });

            obj.offset = obj.offset + len;
            if (obj.offset < (res.count)) {
                await searchAll(obj);
            } else return obj;
        }
    } catch (error) {
        console.log("LOGS: searchAll error", error);
    }
    return obj;
}

export const searchFlex = ({ params, extObj, type, fields }) => {
    let offset = 0;
    let limit = 50;
    let flexClips = [];
    return async (dispatch) => {
        dispatch(actions.updateFlexObjects({ flexLoading: true }));
        let obj = { params, extObj, type, fields, offset, limit, flexClips, dispatch };
        try {
            let res = await searchAll(obj);
            if (res) {
                console.log("LOGS: searchFlex offset len", obj.offset, res.flexClips.length);
                dispatch(actions.updateFlexObjects({ flexClips: [...res.flexClips], flexLoading: false }));
            }
        } catch (err) {
            console.log("LOGS: searchFlex err", err);
        }
        dispatch(actions.updateFlexObjects({ flexLoading: false }));
    }
}

export const searchFlexClips = () => {
    let offset = 0;
    let limit = 500;
    let flexClips = [];
    return async (dispatch, getState) => {
        dispatch(actions.updateFlexObjects({ flexLoading: true }));
        let curObj = getState().flex.flexObjects.currentSearch;
        console.log("LOGS: searchFlexClips currentSearch", curObj);
        if (curObj && curObj.type) {
            let obj = { ...curObj, offset, limit, flexClips, dispatch };
            console.log("LOGS: searchFlexClips obj", obj);
            try {
                let res = await searchAll(obj);
                if (res) {
                    console.log("LOGS: searchFlex offset len", obj.offset, res.flexClips.length);
                    dispatch(actions.updateFlexObjects({ flexClips: [...res.flexClips], flexLoading: false }));
                }
            } catch (err) {
                console.log("LOGS: searchFlex err", err);
            }
            dispatch(actions.updateFlexObjects({ flexLoading: false }));
        }
    }
}